import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import BreadcrumbContainer from './Breadcrumb';
import BackToQueryBreadcrumbsContainer from './BackToQueryBreadcrumbs';

import './NewBreadcrumbs.theme.scss';
import './ResultsBreadcrumbs.theme.scss';

export default class Breadcrumbs extends React.PureComponent {
  render() {
    const { breadcrumbsIds, breadcrumbsOrder } = this.props;

    return (
      <nav className="new-breadcrumbs results-breadcrumbs" aria-label="Breadcrumb" role="navigation">
        <ul className="new-breadcrumbs__list">
          {!breadcrumbsIds.isEmpty() && breadcrumbsOrder === 'tablet' && (
            <BackToQueryBreadcrumbsContainer id={breadcrumbsIds.first()} breadcrumbsOrder={breadcrumbsOrder} />
          )}
          {breadcrumbsIds.map((id, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <BreadcrumbContainer key={index} id={id} index={index} />
          ))}
          {!breadcrumbsIds.isEmpty() && breadcrumbsOrder === 'desktop' && (
            <BackToQueryBreadcrumbsContainer id={breadcrumbsIds.last()} breadcrumbsOrder={breadcrumbsOrder} />
          )}
        </ul>
      </nav>
    );
  }
}

Breadcrumbs.propTypes = {
  breadcrumbsIds: PropTypes.instanceOf(List),
  breadcrumbsOrder: PropTypes.string.isRequired,
};
